import './offers-list';

import './scss/media-list.scss';